import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'
import UserRow from 'components/UserRow'
import { getFullNameUserUtil } from 'models/daos/user/utils'
import { getRelativeUrlReduxUtil } from 'modules/redux/utils/get-url'
import { View } from 'components/View'
import TextBodySmall from 'components/TextBodySmall'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import getValueReduxUtil from 'modules/redux/utils/get-value'

class User extends React.Component {
  static propTypes = {
    value: PropTypes.object
  }

  getProfileUrl () {
    const user = this.props.value
    return getRelativeUrlReduxUtil(user)
  }

  renderAvatar () {
    const { value } = this.props
    return (
      <UserRow.Avatar
        size={UserRow.Avatar.SIZE.MEDIUM}
        value={
          getValueReduxUtil(value, 'avatarThumbnail') ||
          getValueReduxUtil(value, 'avatar')
        }
      />
    )
  }

  renderUserFullName () {
    return (
      <TextBodySmall style={{ marginLeft: STYLES_MARGIN.SMALL }}>
        {
          getFullNameUserUtil(this.props.value)
        }
      </TextBodySmall>
    )
  }

  render () {
    return (
      <Link to={this.getProfileUrl()}>
        <View
          style={{
            flexDirection: View.DIRECTION.ROW,
            alignItems: View.ALIGN.CENTER
          }}
        >
          {this.renderAvatar()}
          {this.renderUserFullName()}
        </View>
      </Link>
    )
  }
}

export default User
